/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_TranscriptInputs */

const en_mk_mx_transcript = /** @type {(inputs: Mk_Mx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step-by-step transcript of every run`)
};

const id_mk_mx_transcript = /** @type {(inputs: Mk_Mx_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkrip langkah setiap run`)
};

/**
* | output |
* | --- |
* | "Step-by-step transcript of every run" |
*
* @param {Mk_Mx_TranscriptInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_transcript = /** @type {((inputs?: Mk_Mx_TranscriptInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_TranscriptInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_transcript(inputs)
	return en_mk_mx_transcript(inputs)
});